import { useDrag } from 'react-dnd';
import { Box } from '@chakra-ui/react';

const DragTypes = {
  FIELD: 'field',
};

const Dragable = ({
  children, id, index, moveField,
}) => {
  const [{ isDragging }, drag] = useDrag({
    type: DragTypes.FIELD,
    item: () => ({ id, index }),
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
    end: (item, monitor) => {
      const dropResult = monitor.getDropResult();
      if (item && dropResult && (item.dropIndex || item.dropIndex === 0) && item.index !== item.dropIndex) {
        moveField(item.index, item.dropIndex, item.id);
      }
    },
  });

  return (
    <Box ref={drag} position="relative" opacity={isDragging ? '0.4' : 1}>
      {children}
    </Box>
  );
};

export default Dragable;
